import { ErpAddressType } from "./erpAddressType";

export class AddressDto {
	public id: number = 0;
	public givenName: string = "";
	public surname: string = "";
	public companyName: string = "";
	public street: string = "";
	public zip: string = "";
	public town: string = "";
	public country: string = "";
	public phone: string = "";
	public eMail: string = "";
	public customerId: number = 0;
	public isDefault: boolean = false;
	public type: ErpAddressType = ErpAddressType.Delivery;
}
